(() => {
  const STORAGE_KEY = 'cardCargoPostageWarningAccepted';

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');

    if (cartDrawer) {
      if (typeof cartDrawer.close === 'function') {
        cartDrawer.close();
      } else {
        const dialog = cartDrawer.querySelector('dialog');

        if (dialog?.open) {
          dialog.close();
        }
      }
    }
  }

  function createPopup() {
    if (document.getElementById('card-cargo-postage-warning')) {
      return;
    }

    const popup = document.createElement('div');

    popup.id = 'card-cargo-postage-warning';

    popup.innerHTML = `
      <div class="card-cargo-postage-backdrop"></div>

      <div
        class="card-cargo-postage-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="card-cargo-postage-title"
      >
        <button
          type="button"
          class="card-cargo-postage-close"
          aria-label="Close"
        >
          ×
        </button>

        <div class="card-cargo-postage-icon">
          📦
        </div>

        <h2 id="card-cargo-postage-title">
          Postage delay
        </h2>

        <p>
          We're taking a break from 2 to 26 October. Orders placed between these dates won't be fulfilled until we're back.
        </p>

        <p>
          We apologise for any inconvenience caused.
        </p>

        <p>
          Thanks for shopping with Card Cargo.
        </p>

        <div class="card-cargo-postage-actions">
          <button
            type="button"
            class="card-cargo-postage-continue"
          >
            Continue to checkout
          </button>

          <button
            type="button"
            class="card-cargo-postage-cancel"
          >
            Return to cart
          </button>
        </div>
      </div>
    `;

    // IMPORTANT:
    // Append directly to body so the popup is not trapped inside
    // the cart drawer's stacking context.
    document.body.appendChild(popup);

    document.body.style.overflow = 'hidden';

    const close = () => {
      popup.remove();
      document.body.style.overflow = '';
    };

    popup
      .querySelector('.card-cargo-postage-close')
      .addEventListener('click', close);

    popup
      .querySelector('.card-cargo-postage-cancel')
      .addEventListener('click', close);

    popup
      .querySelector('.card-cargo-postage-backdrop')
      .addEventListener('click', close);

    popup
      .querySelector('.card-cargo-postage-continue')
      .addEventListener('click', () => {
        sessionStorage.setItem(STORAGE_KEY, 'true');

        close();

        window.location.href = '/checkout';
      });
  }

  function handleCheckoutClick(event) {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      return;
    }

    const element = event.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
    );

    if (!element) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    // Close the Shopify cart drawer first.
    closeCartDrawer();

    // Wait for the drawer's closing animation to finish,
    // then show the warning.
    setTimeout(() => {
      createPopup();
    }, 250);
  }

  document.addEventListener('click', handleCheckoutClick, true);
})();